module.exports = __webpack_public_path__ + "static/img/partner-logo-7.5de8d256.png";